const getPrintingCostByFlyer = ({ printingCosts, flyerType, flyerWeight, flyersAmount }) => {
  if (printingCosts[`${flyerType}#${flyerWeight}`]) {
    const { value } = printingCosts[`${flyerType}#${flyerWeight}`].reduce((acc, printingCost) =>
      Math.abs(printingCost.flyersCount - flyersAmount) < Math.abs(acc.flyersCount - flyersAmount) ? printingCost : acc
    );

    return +value;
  } else {
    return 0;
  }
};

const getDMPrintingCostByFlyer = ({ printingCosts, flyerType, flyersAmount }) => {
  if (printingCosts[flyerType]) {
    const { value } = printingCosts[flyerType].reduce((acc, printingCost) =>
      Math.abs(printingCost.flyersCount - flyersAmount) < Math.abs(acc.flyersCount - flyersAmount) ? printingCost : acc
    );

    return +value;
  } else {
    return 0;
  }
};

const calculateSubtotalAndPrintingCosts = ({
  missionCostWithoutPrinting,
  printingCosts,
  flyerType,
  flyerWeight,
  missionsCount = 0,
  flyerPack,
  outfitTotal,
}) => {
  const flyersAmount = missionsCount * flyerPack;

  const printingCost = getPrintingCostByFlyer({
    printingCosts,
    flyersAmount,
    flyerType,
    flyerWeight,
  });

  const subtotal = printingCost * flyersAmount + missionCostWithoutPrinting * missionsCount + outfitTotal;
  return { subtotal, printingCost };
};

const formatPrintingCosts = (printingCosts) =>
  printingCosts.reduce((acc, item) => {
    if (!acc[item.label]) {
      acc[item.label] = [];
    }
    acc[item.label].push(item);

    return acc;
  }, {});

const getCorrectSettingsObject = ({ countrySettings, citySetting, isD2D }) => {
  const settings = Object.entries(countrySettings).reduce((acc, [key, value]) => {
    acc[key] =
      citySetting[key] === 0 || citySetting[key] === "0" || +citySetting[key] ? +citySetting[key] : +value || 0;

    return acc;
  }, {});

  settings.distributionCosts = isD2D ? settings.d2dDistributionCosts : settings.h2hDistributionCosts;
  settings.flyerPack = isD2D ? settings.flyerPackD2d : settings.flyerPackH2h;
  settings.permitCosts = isD2D
    ? settings.permitCostsD2d
    : settings.permitCostsH2h
  settings.countryTaxRate = countrySettings.countryTaxRate;

  delete settings.d2dDistributionCosts;
  delete settings.h2hDistributionCosts;

  delete settings.flyerPackD2d;
  delete settings.flyerPackH2h;

  delete settings.enabledChannelPreciseLocations;
  delete settings.enabledChannelBroadAreas;
  delete settings.enabledChannelLetterbox;

  return settings;
};

const specialCharacter = "#";

const convertStringSeperatedBySpecialToArray = (str) => (str ? str.split(specialCharacter) : []);

const multiplyMissionsByBA = (missions, baPerLocation) => {
  let totalMissions = [];
  for (let index = 0; index < baPerLocation; index++) {
    totalMissions = [...totalMissions, ...missions];
  }
  return totalMissions;
};

const calculateTotalMissionsH2H = (addresses, baPerLocation = 1) => {
  return addresses.reduce((acc, address) => {
    if (address.isVisible) {
      const startDates = convertStringSeperatedBySpecialToArray(address.startDate || "");
      const times = convertStringSeperatedBySpecialToArray(address.time || "");
      if (startDates.length !== times.length) return acc;

      const newMissions = multiplyMissionsByBA(
        startDates.map((d, index) => ({
          ...address,
          startDate: d,
          endDate: d,
          time: times[index],
        })),
        baPerLocation
      );

      return [...acc, ...newMissions];
    } else {
      return acc;
    }
  }, []);
};

const getTotalETLVolume = (audiences) => {
  return audiences.reduce((total, audience) => {
    const sourceType = audience.sourceType;
    if (sourceType === "ETL") {
      return total + (audience.metadata?.rowsAmount || 0);
    }
    return total;
  }, 0);
};

const findDataCostRate = (printingCosts, volume) => {
  const dataCostKey = 'DATA_COST';
  
  if (!printingCosts[dataCostKey]) return 0;
  
  const { value } = printingCosts[dataCostKey].reduce((acc, dataCost) =>
    Math.abs(dataCost.flyersCount - volume) < Math.abs(acc.flyersCount - volume) 
      ? dataCost 
      : acc
  );
  
  return +value;
};

const getAudienceDataCost = ({ audience, printingCosts }) => {
  if (!audience || !printingCosts) return 0;
  
  const sourceType = audience.sourceType;
  if (sourceType !== "ETL") return 0;
  
  const audienceVolume = audience.metadata?.rowsAmount || 0;
  if (audienceVolume === 0) return 0;
  
  const rate = findDataCostRate(printingCosts, audienceVolume);
  return audienceVolume * rate;
};

const calculateDataCost = ({ audiences, printingCosts }) => {
  if (!audiences || !printingCosts) return 0;
  
  const totalKMLVolume = getTotalETLVolume(audiences);
  if (totalKMLVolume === 0) return 0;
  
  const rate = findDataCostRate(printingCosts, totalKMLVolume);
  return totalKMLVolume * rate;
};

export {
  calculateSubtotalAndPrintingCosts,
  getPrintingCostByFlyer,
  getDMPrintingCostByFlyer,
  formatPrintingCosts,
  getCorrectSettingsObject,
  calculateTotalMissionsH2H,
  calculateDataCost,
  getAudienceDataCost,
};
